<template>
  <div class="content">
    <base-header :choose-index="0" ref="header_content"></base-header>
    <div class="middle_content" ref="middle_content">
      <swiper :options="swiperOption" class="swiper-container" :style="{'height': middle_height}">
        <swiper-slide v-for="(item, index) in content_index_banner" :key="index">
          <a :href="item.banner_link" target="_blank">
            <div class="middle_content-post" v-bgImg="utils.getQiniuWidthUrl(item.banner_img, 1920, 1, 'webp')"></div>
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="middle_content-classify">
        <div class="middle_content-classify-container">
          <a :href="'/product?id='+item.category_id" class="middle_content-classify-item"
            :style="{'width':1200/website_product_categories.length+'px'}"
            v-for="item in website_product_categories" :key="item.category_id">
            <div class="middle_content-classify-item-pic"
              v-bgImg="utils.getQiniuWidthUrl(item.category_icon_black, 70, 3, 'png')"></div>
            <div>{{item.category_name}}</div>
          </a>
        </div>
      </div>
      <div class="middle_content-pro" v-if="showPic">
        <a :href="content_index_three[0].three_link" target="_blank">
          <div class="middle_content-pro-left-pic"
            v-bgImg="utils.getQiniuWidthUrl(content_index_three[0].three_img, 1200, 3, 'webp')"></div>
        </a>
        <!-- <img class="middle_content-pro-pic1" ref="post" src="@@/assets/img/westa/home/img01.png" /> -->
        <div class="middle_content-pro-right">
          <a :href="content_index_three[1].three_link" target="_blank">
            <div class="middle_content-pro-right-pic"
              v-bgImg="utils.getQiniuWidthUrl(content_index_three[1].three_img, 580, 3, 'webp')"></div>
          </a>
          <a :href="content_index_three[2].three_link" target="_blank">
            <div class="middle_content-pro-right-pic1"
              v-bgImg="utils.getQiniuWidthUrl(content_index_three[2].three_img, 580, 3, 'webp')"></div>
          </a>
        </div>
      </div>
    </div>
    <base-footer></base-footer>
  </div>
</template>

<script>
import BaseHeader from "@@/components/westa/base-header";
import BaseFooter from "@@/components/westa/base-footer";
export default {
  data() {
    return {
      middle_height: "0",
      swiperOption: {
        autoplay: true,
        autoplay: {
          disableOnInteraction: false
        },
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        }
      },
      content_index_banner: [],
      content_index_three: [],
      showPic: false,
      website_product_categories: [],
      isHome: true
    };
  },
  components: {
    BaseHeader,
    BaseFooter
  },
  created() {
    this.getInfo();
    this.getCategories();
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll, true);
    this.init();
  },
  methods: {
    init() {
      this.middle_height = window.innerHeight - 64 + "px";
      console.log(window.innerHeight);

      // this.middle_height = window.innerHeight;
    },
    // handleScroll() {
    //   let top =
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop ||
    //     window.pageYOffset;
    //   if (top === 0) {
    //     this.isHome = true;
    //     // return;
    //   } else {
    //     this.isHome = false;
    //   }
    //   // console.log(top);
    // },
    getInfo() {
      let params = {};
      this.req
        .get(
          url_api_web_websiteContent_getWebsiteContent,
          this.qs.stringify(params)
        )
        .then(result => {
          this.content_index_banner = JSON.parse(
            result.website_content.content_index_banner
          );
          this.content_index_three = JSON.parse(
            result.website_content.content_index_three
          );
          this.showPic = true;
        })
        .catch(error => { });
    },
    getCategories() {
      let params = {};
      this.req
        .get(
          url_api_web_websiteProductCategory_getWebsiteProductCategories,
          this.qs.stringify(params)
        )
        .then(result => {
          this.website_product_categories = result.website_product_categories;
        })
        .catch(error => { });
    }
  }
  // destroyed() {
  //   console.log("destory");
  //   window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
  // }
};
</script>


<style lang="less" scoped>
.middle_content {
  padding-top: 64px;
  background: #f9f9f9;
  min-width: 1200px;

  &-post {
    width: 100%;
    height: 100%;
  }
  &-classify {
    width: 1200px;
    height: 240px;
    margin: 40px auto;
    // align-items: center;
    // justify-content: flex-start;
    // flex-wrap: wrap;
    // flex-shrink: 0;
    background: #fff;
    color: #333;
    margin-bottom: 20px;
    overflow: hidden;
    &-container {
      display: flex;
      overflow-x: scroll;
      overflow-y: hidden;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
    }
    &-item {
      width: 240px;
      height: 240px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      box-sizing: border-box;
      &-pic {
        width: 70px;
        height: 70px;
        margin-bottom: 16px;
      }
      &:hover {
        box-shadow: 0 0 6px 1px #999999;
      }
    }
  }
  &-pro {
    width: 1200px;
    // height: 604px;
    margin: 0 auto;
    padding-bottom: 40px;
    display: flex;
    &-pic1 {
      width: 1200px;
      height: 662px;
      margin-bottom: 20px;
    }
    &-pic2 {
      width: 590px;
      height: 756px;
    }
    &-left {
      &-pic {
        width: 590px;
        height: 604px;
      }
    }
    &-right {
      margin-left: 20px;
      &-pic {
        width: 590px;
        height: 294px;
      }
      &-pic1 {
        width: 590px;
        height: 294px;
        margin-top: 16px;
      }
    }
  }
}
.header-swipe {
  background: transparent;
}
</style>
<style>
/* @keyframes load {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(-720deg);
    border-left: 2px solid #868686;
  }
}*/
.swiper-pagination-bullet-custom {
  width: 10px;
  height: 10px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: gray;
  opacity: 1;
  background: rgba(0, 0, 0, 0.3);
  margin-right: 6px;
}
.swiper-pagination-bullet-custom.swiper-pagination-bullet-active {
  width: 10px;
  height: 10px;
  background: rgba(0, 0, 0, 0.8);
  /* border: 2px solid #fff; */
  /* animation: load 1s linear infinite; */
}
/*
.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 15px;
}
.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 46px;
} */
</style>


